import { useEffect } from "react";
import gsap from "gsap";

const CursorFollowerProvider = () => {
  useEffect(() => {
    // Check if it's a touch device
    const isTouchDevice = "ontouchstart" in window;

    const createCursorFollower = () => {
      const $el = document.querySelector(".cursor-follower");

      window.addEventListener("mousemove", (e) => {
        const { target, x, y } = e;

        // Check if target is inside a link or button

        const isTargetLinkOrBtn =
          // eslint-disable-next-line
          // @ts-ignore
          target?.closest("a") || target?.closest("button");

        gsap.to($el, {
          x: x + 3,
          y: y + 3,
          duration: 0.7,
          ease: "power4.out", // More easing options here: https://gsap.com/docs/v3/Eases/
          opacity: isTargetLinkOrBtn ? 0.1 : 0.3,
          transform: `scale(${isTargetLinkOrBtn ? 3 : 1})`,
        });
      });
      // Hidding the cursor element when the mouse cursor
      // is moved out of the page
      document.addEventListener("mouseleave", () => {
        gsap.to($el, {
          duration: 0.7,
          opacity: 0,
        });
      });
    };

    // Only invoke the functions if isn't a touch device
    if (!isTouchDevice) {
      createCursorFollower();
    }
  }, []);

  return <div className="cursor-follower"></div>;
};

export default CursorFollowerProvider;
